import { Button, CheckboxFormField, ClassName, Form, IFormRender, Theme } from '@busybusy/webapp-react-ui';
import { EquipmentInspectionPermission } from '__generated__/graphql';
import classNames from 'classnames';
import DashboardRibbon from 'components/foundation/dashboard/DashboardRibbon/DashboardRibbon';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { usePositionUpdate } from 'hooks';
import { t } from 'i18next';

export interface IEquipmentInspectionsFormProps {
  className?: ClassName;
  positionId: string;
  onSubmit: (formData: IEquipmentInspectionsFormData) => void;
  currentSetting: EquipmentInspectionPermission;
}

interface IEquipmentInspectionsFormData {
  createEquipmentInspections: boolean;
  manageEquipmentInspections: boolean;
}

const EquipmentInspectionsForm = (props: IEquipmentInspectionsFormProps) => {
  const { positionId, onSubmit, currentSetting, className } = props;

  const [, update] = usePositionUpdate();

  const initialFormData: IEquipmentInspectionsFormData = {
    manageEquipmentInspections: currentSetting === EquipmentInspectionPermission.Manage,
    createEquipmentInspections:
      currentSetting === EquipmentInspectionPermission.Manage ||
      currentSetting === EquipmentInspectionPermission.Perform,
  };

  async function onFormSubmit(formData: IEquipmentInspectionsFormData) {
    if (formData.createEquipmentInspections) {
      if (formData.manageEquipmentInspections) {
        await update({ equipmentInspections: EquipmentInspectionPermission.Manage, id: positionId });
      } else {
        await update({ equipmentInspections: EquipmentInspectionPermission.Perform, id: positionId });
      }
    } else {
      await update({ equipmentInspections: EquipmentInspectionPermission.ClockIn, id: positionId });
    }
    onSubmit(formData);
  }

  function renderFormFields(form: IFormRender<IEquipmentInspectionsFormData>) {
    return (
      <>
        <CheckboxFormField
          name="createEquipmentInspections"
          form={form}
          label={
            <HeaderText title={t('Perform Equipment Inspections')}>
              <span>
                {t(
                  'Allow the employee to perform routine and ad hoc inspections (All employees can complete pre- and post-operation inspections when performing clock actions).'
                )}
              </span>
            </HeaderText>
          }
          onChange={(val) => {
            if (val === false) {
              form.setData('manageEquipmentInspections', false);
            }
          }}
        />
        {form.state.data.createEquipmentInspections && (
          <DashboardRibbon theme={Theme.LIGHT}>
            <CheckboxFormField
              name="manageEquipmentInspections"
              form={form}
              label={
                <HeaderText title={t('Manage Equipment Inspections')}>
                  <span>{t('View, resolve, and delete equipment inspections created by others.')}</span>
                </HeaderText>
              }
            />
          </DashboardRibbon>
        )}
        <Button type={'primary'} className={'mt-6'} onClick={form.handleSubmit}>
          {t('Update')}
        </Button>
      </>
    );
  }

  const classes = classNames('equipment-inspections-form m-8', className);

  return (
    <div className={classes}>
      <Form render={renderFormFields} data={initialFormData} onSubmit={onFormSubmit} />
    </div>
  );
};

export default EquipmentInspectionsForm;
